import { useEffect, useMemo } from 'react'
import { motion } from 'framer-motion'
import { useCurrentConversationStore } from '@/store/useCurrentConversationStore'

export default function GradientWrapper({ children }) {
  const isNewChat = useCurrentConversationStore(state => state.id) === null

  const gradientLayers = useMemo(
    () =>
      [
        'linear-gradient(130deg, hsl(var(--ink-900) / 0.96) 0%, hsl(var(--ink-850) / 0.94) 32%, hsl(var(--iron-700) / 0.78) 66%, hsl(var(--teal-500) / 0.18) 100%)',
        'radial-gradient(circle at 18% 20%, hsl(var(--teal-450) / 0.42) 0%, transparent 50%)',
        'radial-gradient(circle at 78% 12%, hsl(var(--teal-400) / 0.35) 0%, transparent 48%)',
        'linear-gradient(180deg, hsl(var(--ink-950) / 0.88) 0%, hsl(var(--ink-900) / 0.92) 55%, hsl(var(--ink-950) / 0.96) 100%)',
      ].join(', '),
    []
  )

  useEffect(() => {
    document.body.classList.toggle('new-chat', isNewChat)
    return () => document.body.classList.remove('new-chat')
  }, [isNewChat])

  if (!isNewChat) {
    return (
      <div className="relative flex h-full flex-col bg-background text-foreground">
        {children}
      </div>
    )
  }


  return (
    <motion.div
      className="new-chat relative flex h-full flex-col overflow-hidden text-white"
      animate={{
        backgroundPosition: [
          '0% 0%, 20% 18%, 80% 0%, 0% 0%',
          '0% 65%, 28% 38%, 60% 12%, 0% 90%',
          '0% 0%, 16% 18%, 82% 0%, 0% 0%',
        ],
        filter: ['saturate(0.96)', 'saturate(1.05)', 'saturate(0.96)'],
      }}
      transition={{ duration: 22, ease: 'easeInOut', repeat: Infinity }}
      style={{
        backgroundImage: gradientLayers,
        backgroundSize: '150% 150%, 130% 130%, 130% 130%, 100% 100%',
        backgroundBlendMode: 'screen, lighten, screen, normal',
        backgroundAttachment: 'fixed',
      }}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-55 mix-blend-screen"
        style={{
          backgroundImage:
            'radial-gradient(circle at 30% 22%, rgba(120,170,220,0.18) 0%, transparent 55%), radial-gradient(circle at 72% 58%, rgba(90,200,200,0.14) 0%, transparent 52%)',
          filter: 'blur(46px)',
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.16]"
        style={{
          backgroundImage:
            'radial-gradient(circle at 50% -10%, rgba(255,255,255,0.22) 0%, transparent 55%)',
          mixBlendMode: 'soft-light',
        }}
      />
      <div className="relative z-[1] flex h-full flex-col">{children}</div>
    </motion.div>
  )
}
